<template>
	<div class="instance-component" ref="iTable"  
		v-bind:style="{
			'min-width': tableWidth +'px',
			'max-width': tableWidth +'px'
		}"
	>
		<div v-for="(cI, index) in orderedInstances"
			v-on:click.stop="activeChild ? cancelEdit(cI) : (enableEdit ? editInstance(cI) : selectInstance(cI))"
			v-on:keyup.esc="cancelEdit(cI)"
			class="row"
			tabindex="0" 
			v-bind:key='index'
			v-bind:class="{edit:enableHighLight(this.editMode,cI), 'box-top-border': index === 0, 'root-row': index === 0}"
			v-bind:style="{'padding-left': (cI.editBuffer=='00100'?cI.ClientBranch.indent*10:0) +'px'}"
		>
		<!-- v-bind:disabled="!enableClientInstance(cI)" -->


			<!-- Cancel Button -->
			<button v-if="cI.editBuffer.substr(0,1)=='1'"
				v-on:click.stop="cancelEdit(cI)"
				class="button edit cancel"
				type="button"
			>X</button>
			<!-- Remove Button -->
			<button v-if="cI.editBuffer.substr(1,1)=='1'"
				v-on:click.stop="autoComplete(cI,{item:cI.iBranch.Child, code:4})"
				class="button edit" 
				type="button"
			>R</button>
			
			<!-- Default Display  -->
			<div v-if="cI.editBuffer.substr(2,1)=='1'"
				v-text="instanceOrDigest(cI)"
				class="default"
				ref="instanceValue"
				tabindex="0"
			/>

			<!-- Answer a Question -->
			<InstanceRequest v-if="cI.editBuffer.substr(3,1)=='1'"
				v-on:response="cIResponse(cI, cI.clientInstanceRequest.Instance, cI.clientInstanceRequest.mode, $event)"
				v-bind:request="cI.clientInstanceRequest.req"
				v-bind:buttons="cI.clientInstanceRequest.buttons"
			/>	


			<!-- Edit Instance.value-->
			<InstanceAutocomplete	v-if="cI.editBuffer.substr(4,1)=='1'"
				v-on:selectedItem="autoComplete(cI,$event)"
				class="select-instance"
				v-bind:authStatus="authStatus"
				v-bind:vars="autoCompleteVars(cI)"
				v-bind:defaultItem="cI.iBranch?.Child || {}"
			/>		
		</div>
		<div
			v-if="ITree.displayImages"
			class="image-preview"
		>
			<div v-if="isLoadingImages">Loading image preview...</div>
			<div v-else-if="imageError" class="image-error">{{ imageError }}</div>
			<img
				v-else-if="imageUrl"
				v-bind:src="imageUrl"
				alt="Image preview"
				class="image-thumb"
				@dblclick="openViewer"
				style="cursor: pointer;"
			/>
		</div>
	</div>
</template>

<script>
	import _ from 'lodash'  // this is needed to use the sort function
	import InstanceRequest from       './InstanceRequest.vue'
	import InstanceAutocomplete from  './InstanceAutocomplete.vue'

	export default {
		name: 'InstanceView',
		components: {InstanceAutocomplete, InstanceRequest},
		props: {
			activeChild:{
				type: Boolean,
				required: true
			},
			authStatus:{
				type: Object,
				required: true
			},
			clickToFilter:{
				type:Boolean,
				required:false
			},
			editMode:{
				type:Number,
				required: true
			},
			enableEdit:{
				type: Boolean,
				required: true,
			},
			showHiddenBranches:{
				type:Boolean,
				required:false,
				default:false
			},
			rootInstanceID:{
				type:String,
				required:false
			},
			ITree: {
				type: Object,
				required: false,
			},
			tableWidth: {
				type: Number,
				required:false
			}
		},
		data() {
			return {
				imageUrl: '',
				isLoadingImages: false,
				imageError: ''
			}
		},
		methods: {
			autoComplete(ClientInstance, vars){
				// console.log('autoComplete' , vars)
				// handle autoComplete event
				const {item, code} = vars
				var action = ''
				if(code == 0){
					this.cancelEdit(ClientInstance)
					this.$emit('setActiveRequest',false)
				}else{
					if(code == 1){
						action = 'updateInstanceValue'
					}
					if(code == 2){
						action = 'addExistingInstance'
					}1
					if(code == 3){
						action = 'addNewInstance'
					}
					if(code == 4){
						action = 'removeClientInstance'
					}
					this.$emit('clientInstanceRequest',{
						ClientInstance:ClientInstance,
						code:code,
						item:item,
						action:action
					})
				}
			},
			autoCompleteVars (ClientInstance){
				if(_.isEmpty(ClientInstance.iBranch)){
						return {
						isCollection: false,
						editOnly: false, 
						nodID: ClientInstance.ClientBranch.Branch.Child.ID,
					}
				}else{
					return {
						isCollection: ClientInstance.ClientBranch.Branch.Child.isCollection,
						editOnly: ClientInstance.iBranch?true:false, 
						nodID: ClientInstance.ClientBranch.Branch.Child.ID,
					}
				}
			},		
			async loadImagePreviews(){
				// Fetch signed URL for the single image associated with the Image branch
					if(!this.ITree?.displayImages){
					this.imageUrl = ''
					this.imageError = ''
					return
				}
				// Find ClientInstance with the key Nod (constant ID: 37da8b91-bff2-4455-b533-f4d4fa5e4db4)
				const imageCI = (this.ITree?.ClientInstances || []).find(cI =>
					cI?.ClientBranch?.Branch?.Child?.ID === '37da8b91-bff2-4455-b533-f4d4fa5e4db4')
				// ownerIdentityId will be looked up later if needed
				
				// console.log('Available Nods:', (this.ITree?.ClientInstances || []).map(cI => ({
				// 	nodId: cI?.ClientBranch?.Branch?.Child?.ID,
				// 	nodName: cI?.ClientBranch?.Branch?.Child?.name,
				// 	value: cI?.iBranch?.Child?.valueGood
				// })))
				
				if(!imageCI){
					this.imageUrl = ''
					this.imageError = ''
					return
				}
				
				this.isLoadingImages = true
				this.imageError = ''
				try{
					const compositeKey = imageCI.iBranch.Child.value
					// Extract filename from composite key (format: createdBy|filename)
					const imageKey = compositeKey.includes('|') ? compositeKey.split('|')[1] : compositeKey
					// Guard: only attempt preview for common image types
					if (!this.isImageExtension(imageKey)) {
						this.isLoadingImages = false
						this.imageError = 'Preview not supported for this file type'
						return
					}
					
					// Use our own backend API instead of Amplify getUrl
					const token = localStorage.getItem('user-token') || sessionStorage.getItem('user-token');
					const baseUrl = process.env.VUE_APP_GRAPHQL_URL.replace('/graphql', '');
					const hash = imageKey.split('.')[0]; // Assuming imageKey is hash.ext
					
					const response = await fetch(`${baseUrl}/api/file/${hash}`, {
						headers: {
							'Authorization': `Bearer ${token}`
						}
					});

					if (!response.ok) throw new Error('Failed to fetch image');

					const blob = await response.blob();
					const reader = new FileReader();
					reader.onloadend = () => {
						this.imageUrl = reader.result;
						this.isLoadingImages = false;
					};
					reader.onerror = () => {
						this.imageError = 'Failed to process image';
						this.isLoadingImages = false;
					};
					reader.readAsDataURL(blob);
				}catch(err){
					console.log('Image preview error:', err)
					this.imageError = 'Unable to load image preview'
					this.isLoadingImages = false
				}
			},
			isImageExtension(filename) {
				if (!filename) return false;
				return /\.(jpe?g|png|gif|bmp|webp|tiff?)$/i.test(filename);
			},
			cancelEdit(ClientInstance) {
				// console.log('cancelEdit', this.activeChild)
				// Only cancel if this ClientInstance is actually being edited
				if (ClientInstance.editBuffer.substr(0,1) === '1') {
					this.$emit('activateChild', false)
					this.$emit('clientInstanceDisplay', {
						ClientInstance: ClientInstance,
						operation: 'cancel'
					})
				}
			},
			editInstance(ClientInstance) {
				// console.log('editInstance', this.activeChild)
				if (this.activeChild) return;
				if (this.enableEdit !== true) return;

				// you can only edit level 1 items in the tree
				const indent = ClientInstance.ClientBranch.indent
				if (indent !== 1) return;
				const isCollection = ClientInstance.ClientBranch.Branch.Child.isCollection
				const element = this.editMode == 3 ? (ClientInstance.iBranch.Child ? 'removeClientInstance' : 'updateValue') : ''

				if (isCollection) {
					// console.log('editInstance - isCollection')
					const rootInstance = this.ITree.ClientInstances[0].iBranch.Child || ''
					const vars = {
						rootNod: ClientInstance.ClientBranch.Branch.Child,
						rootInstanceID: rootInstance.ID || '',
						ClientInstance: ClientInstance,
						selectedInstances: [],
						state: true
					}
					this.$emit('callModalCollection', vars)

				} else {
					// console.log('editInstance - !isCollection') 
					this.$emit('activateChild', true)
					this.$emit('clientInstanceDisplay', {
						ClientInstance: ClientInstance,
						operation: element
					})
				}
			},
			selectInstance(ClientInstance) {
				// console.log('selectInstance', ClientInstance)
				if (this.activeChild) return;
				if (this.enableEdit !== false) return;
				const isCollection = ClientInstance.ClientBranch.Branch.Child.isCollection
				const isEditTarget = ClientInstance.enableEdit
				const destination = isCollection ? 'isCollection' : isEditTarget ? 'edit' : this.clickToFilter ? 'filter' : 'mutate'
				if (destination == 'filter') {
					// console.log('selectInstance - Filter') 
					if (!_.isEmpty(ClientInstance.iBranch)) {
						const vars = {
							ClientBranch: ClientInstance.ClientBranch,
							Instance: ClientInstance.iBranch.Child,
						}
						this.$emit('updateCBFilter', vars)
					}
				} else {
					// console.log('selectInstance - Edit')
					// you clicked an Instance to copy to the edit target.
					// target cell is a value then
					if (!ClientInstance.ClientBranch.Branch.Child.isCollection) {
						const vars = {
							Branch: ClientInstance.ClientBranch.Branch,
							Instance: ClientInstance.iBranch.Child,
						}
						// copy Instance to target
						this.$emit('findTargetInstance', vars)
					}
				}
			},
			enableHighLight(editMode,ClientInstance){
				// console.log('enableHighLight', editMode)
				if(editMode == 2){
					return _.isEmpty(ClientInstance.iBranch)?false:true
				}
				if(editMode == 3){
					// return true
					return ClientInstance.ClientBranch.indent == 1?true:false
				}
			},
			openViewer() {
				if (this.imageUrl) {
					this.$emit('open-viewer', { ITreeID: this.ITree.ID, imageUrl: this.imageUrl });
				}
			},
			instanceOrDigest(ClientInstance){  // return the instance.value or digest depending on child visibility
				// const iBranch = ClientInstance.iBranch
				const digestString = this.$digestString(ClientInstance,this.ITree.ClientInstances)
				if(ClientInstance.ClientBranch.Branch.Child.isCollection && !ClientInstance.ClientBranch.showChildren){
					if(digestString !== ''){
						return digestString
					} else {
						return '* * *' //"iBranch.ID
					}
				}else{	
					if(ClientInstance.iBranch.Child){
						return ClientInstance.iBranch.Child.value
					}else{
						return ClientInstance.iBranch.ID
					}
				}
			},
			cIResponse(ClientInstance, Instance, action, response){
				const vars = {
					ClientInstance:ClientInstance,
					action:action,
					response:response,
					Instance:Instance
				}
				// console.log('cIResponse', vars)
				this.$emit('clientInstanceResponse', vars)
			}
		},
		computed:{
			orderedInstances: function () {
				// Determine instance row visibility per editMode and Branch.isHidden
				const filtered = this.ITree.ClientInstances.filter(ci => {
					const isVisibleLocal = ci.ClientBranch.isVisible
					const isHidden = ci.ClientBranch?.Branch?.isHidden === true
					// Edit mode 0: respect local visibility
					if (this.editMode === 0) {
						return isVisibleLocal
					}
					// Edit mode > 0: hide hidden branches from UI but keep them in data unless explicitly shown
					if (isHidden && !this.showHiddenBranches) {
						return false
					}
					return isVisibleLocal
				})
				return _.orderBy(filtered, 'ClientBranch.path', 'asc')
			},
		},
		watch:{
			'ITree.displayImages': {
				immediate: true,
				handler(val){
					if(val){
						this.loadImagePreviews()
					}else{
					this.imageUrl = ''
						this.imageError = ''
					}
				}
			},
			'ITree.ClientInstances': {
				deep: true,
				handler(){
					if(this.ITree.displayImages){
						this.loadImagePreviews()
					}
				}
			}
		}
	}
</script>

<style scoped>

	.instance-component{
		position: relative;
	}

	* {
		padding: 0;
		margin: 0;
		border:none;
	}

	.cell{
		border-left:  .1px solid black;
		border-right: .1px solid black;
	}

	.row {
		border-left: 1px solid black;
		border-bottom: 1px solid black;
		border-right: 1px solid black;
		box-sizing: border-box;
		display: flex;
		height: 24px;
		flex-wrap: nowrap;
		align-items: center;
	}
	.row.root-row {
		position: sticky;
		top: 0;
		z-index: 120;
		background-color: inherit;
	}
	.row.root-row > * {
		background-color: inherit;
	}

	.box-top-border {
		border-top: 1px solid black;
	}

	.default{
		align-items: center;
		display: flex;
		padding-left: 2px;
		width:100%;
	}

	.edit:hover {
		background-color: #a6f4e5;
		cursor: pointer;
	}

	.popup-div{
		display: inline-flex;
		z-index: 1000;
		background-color: #a6f4e5;
	}

	.button{
		border: .1px solid black;
		border-radius: 4px;
		display: flex;
		justify-content: center;
		height: 24px;
		min-width: 17px;
		background-color: transparent;
	}

	.col-head{
		border: none;
		text-align: center;
		font-weight: bold;
	}

	.td{
		padding-right: 5px;
	}

	.default:empty:before{
		content:"\00a0\00a0\00a0\00a0\00a0\00a0\00a0\00a0";
	}

.select-instance{
	display: flex;
	align-items: center;
}
	.instance-div{
		display:flex;
		align-items: center;
		overflow: visible;
	}

	.select{
		width: 22px;
		display: flex;
	}

	.spacer{
		width: 10px;
		border: none;
	}

	.image-preview{
		margin-top: 8px;
	}
	.image-error{
		color: #b00020;
		font-weight: 600;
	}
	.image-grid{
		display: flex;
		flex-wrap: wrap;
		gap: 6px;
	}
	.image-thumb{
		width: 96px;
		height: 96px;
		object-fit: cover;
		border: 1px solid #cfd8dc;
		border-radius: 4px;
		background: #f7f9fa;
	}

</style>
